


















import { Component, Prop } from 'vue-property-decorator';

import AppVue from '@/AppVue.vue';
import { QuestionnaireModel } from '@/core/models';

@Component
export default class QuestionnaireStep4Cpt extends AppVue {
  @Prop() model: QuestionnaireModel;
  //
}
